<div class="flex-container">
  <div class="flex-item">
    <mat-list>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.id' | transloco }}</span>
        <span matListItemLine>{{ order.id }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.dateRequested' | transloco }}</span>
        <span>{{ order.dateRequested | localizedDate }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.visibility' | transloco }}</span>
        <span matListItemLine>{{ order.isVisible ? 'Visible' :
          'Deleted'
        }}</span>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="flex-item">
    <mat-list class="flex-item">
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.registrationNumber' | transloco }}</span>
        <span>{{ order.lien?.registrationNumber ?? 'N/A' }}</span>
      </mat-list-item>
      @if (order.jurisdiction == 'ON') {
        <mat-list-item>
          <span matListItemTitle>{{ 'common.labels.onFileNumber' | transloco }}</span>
          <span>{{ order.lien?.fileNumber ?? 'N/A' }}</span>
        </mat-list-item>
      }
      <mat-list-item>
        <span matListItemTitle>{{ 'renewalOrderPreview.term' | transloco }}</span>
        <span>{{ order.lien?.term }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.securedPartyName' | transloco }}</span>
        <span>{{ getFirstSecuredPartyName(order) }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.debtorName' | transloco }}</span>
        <span>{{ getFirstDebtorName(order) }}</span>
      </mat-list-item>
    </mat-list>
  </div>
</div>